import colors from "@assets/colors";
import { useTextWidth } from "@tag0/use-text-width";
import React from "react";
import { Group, Rect } from "react-konva";
import { Html } from "react-konva-utils";
import { TextInput, View } from "react-native";
import { CanvasContext } from "../../provider/canvas";
import { mobileSize, tabletSize } from "@src/utils/screensize-helper";

type QRCodeSignProps = {
  field: any;
  onTextFocus?: () => void;
  onTextUpdate?: (value: any) => void;
  onSelectTextBox?: () => void;
};

const TextBox = (props: QRCodeSignProps) => {
  const { field } = props;
  const inputRef = React.useRef<any>();
  const { canvas } = React.useContext(CanvasContext);
  const [focus, setFocus] = React.useState<boolean>(false);
  const [input, setInput] = React.useState<string>(field.text);
  const textWidth = useTextWidth({ text: input || " ", font: "14.69px Times" });
  const contentWidth = textWidth > field.config.width ? textWidth : field.config.width;
  const isMobile = mobileSize();
  const isTablet = tabletSize();

  const onBlur = () => {
    setFocus(false);
    if (props.onTextUpdate)
      props.onTextUpdate({input, textWidth: Math.abs(textWidth / canvas.scale)});
  };

  React.useEffect(() => {
    const maxWidth = (canvas.width * canvas.scale) - field.config.x;

    if(textWidth > maxWidth && input){
      setInput(input.slice(0, -1));
    }
  }, [input, textWidth, canvas]);

  React.useEffect(() => {
    if (field.isFocus) {
      inputRef?.current?.focus();
    }
  }, [field.isFocus]);

  return (
    <React.Fragment>
      <Group
        x={field.config.x}
        y={field.config.y}
        width={contentWidth}
        height={field.config.height}
        rotation={field.config.rotation}
        onClick={(isMobile || isTablet) ? props.onSelectTextBox : props.onTextFocus}
        onTap={(isMobile || isTablet) ? props.onSelectTextBox : props.onTextFocus}
        onDblTap={(isMobile || isTablet) ? props.onSelectTextBox : props.onTextFocus}
      >
        <Rect width={contentWidth} height={field.config.height} />
        <Html
          divProps={{
            style: {
              zIndex: -1,
              width: contentWidth,
              height: field.config.height,
              pointerEvents: "none",
              backgroundColor: colors.transparent
            },
          }}
        >
          <View style={{
            minWidth: contentWidth,
            height: field.inputConfig.height,
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: colors.lightGray
          }}>
            <TextInput
              ref={inputRef}
              numberOfLines={1}
              style={{
                paddingLeft: 2,
                fontFamily: "DMSans",
                minWidth: contentWidth,
                height: field.inputConfig.height,
                fontSize: field.inputConfig.fontSize
              }} 
              value={(isMobile || isTablet) ? props.field.text : input}
              onBlur={onBlur}
              onChangeText={setInput}
              onFocus={() => setFocus(true)}
              placeholder={focus ? "" : "Type here..."} />
          </View>
        </Html>
      </Group>
    </React.Fragment>
  );
};

export default React.memo(TextBox);
